import { useState } from "react";
import HeroSection from "./HeroSection";
import Banner from "../../Assets/Images/faq_banner.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleChevronDown, faCircleChevronUp } from '@fortawesome/free-solid-svg-icons';

const AccordionItem = ({ id, question, answer, isOpen, toggle }) => {
    return (
        <div className="accordion-item border-0 mb-4">
            <h2 className="accordion-header w-100">
                <button
                    className={`accordion-button shadow-none px-3 py-3 ${isOpen ? 'open' : 'collapsed'}`}
                    type="button"
                    onClick={() => toggle(id)}
                >
                    <span className="w-100 d-flex justify-content-between ">
                        {!isOpen ? (
                            <>
                                <p className="question-text">{question}</p>
                                <span className="icon ms-auto">
                                    <span className="arrow-indicator ">
                                        <FontAwesomeIcon icon={faCircleChevronDown} />
                                    </span>
                                </span>
                            </>
                        ) : (
                            <>
                                <p className="accordion-text open text-white">{answer}</p>

                                <span className="arrow-indicator ">
                                    <FontAwesomeIcon icon={faCircleChevronUp} />
                                </span>                            </>
                        )}
                    </span>
                </button>
            </h2>
        </div>
    );
};

const Faq = () => {
    const [openItems, setOpenItems] = useState([]);

    const toggleItem = (id) => {
        setOpenItems((prev) =>
            prev.includes(id) ? prev.filter((key) => key !== id) : [...prev, id]
        );
    };

    const items = [
        {
            id: '1',
            question: 'How do I choose the best event management company?',
            answer:
                'Hire an experienced event planner with a strong portfolio, great client reviews, and expertise in designing seamless and engaging events according to your needs.',
        },
        {
            id: '2',
            question: 'What are the benefits of hiring a professional event planner?',
            answer:
                'An expert event planner assures smooth execution, coordinates logistics, provides creative solutions, and saves time while delivering a stress-free and memorable event experience.',
        },
        {
            id: '3',
            question: 'How much does event management cost in India?',
            answer:
                'Event management prices depend on event type, size, location, services needed, and customization requirements. It is best to obtain a customized quote as per specific needs.',
        },
        {
            id: '4',
            question: 'What types of corporate events do you organize?',
            answer:
                'We deal with planning corporate seminars, product launches, business conferences, award functions, networking events, trade shows, and employee engagement activities.',
        },
        {
            id: '5',
            question: 'How do you manage large-scale corporate events and conferences?',
            answer:
                'With meticulous planning, cutting-edge technology, and smooth-as-silk coordination, we offer event flow, high traffic, and smooth execution even in large conferences.',
        },
        {
            id: '6',
            question: 'Do you provide end-to-end corporate event planning services?',
            answer:
                'Yes, we design comprehensive corporate event planning such as venue choice, logistics, branding, marketing, audiovisual installation, and on-site management to make your experience hassle-free.',
        },
        {
            id: '7',
            question: 'Can you help with branding and promotions for corporate events?',
            answer:
                'Yes, we create strategic branding campaigns, event promotion, and audience engagement plans to ensure maximum visibility and impact for corporate events.',
        },

    ];

    return (
        <div className="faq">
            <HeroSection image={Banner} pageTitle="FaQ" />
            <section className="d-flex flex-column justify-content-center align-items-center text-center">
                <div className="container">
                    <h2>Get quick solutions here</h2>
                </div>
            </section>
            <section className="pt-0">
                <div className="container">
                    <div className="accordion" id="eventAccordion">
                        {items.map((item) => (
                            <AccordionItem
                                key={item.id}
                                id={item.id}
                                question={item.question}
                                answer={item.answer}
                                isOpen={openItems.includes(item.id)}
                                toggle={toggleItem}
                            />
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Faq;
